import Checkbox from "@app/components/checkbox";
import CustomAsyncMultiSelect from "@app/components/custom-async-multi-select";
import { FormControl } from "@app/components/form-control";
import Input from "@app/components/input";
import { UserTypeOptions } from "@app/constants";
import { ChangeEvent, useCallback, useState } from "react";
import BookService from "@app/services/http/book.service";
import { LabelValue } from "@app/types";

const CampaignComponent = () => {
  const [isTypeUser, setIsTypeUser] = useState(false);
  const [isPriceRange, setIsPriceRange] = useState(false);

  const handleTypeUserChange = (e: ChangeEvent<HTMLInputElement>) => {
    setIsTypeUser(e.target.checked);
  };

  const fetchUserOptions = async (inputValue: string) => {
    return UserTypeOptions.filter((option) => option.value !== "ALL").filter(
      (option) => option.label.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  const fetchBookOptions = useCallback(async (inputValue: string) => {
    const res = await BookService.getRetailBooks(
      { keyword: inputValue, pageNum: 1, pageSize: 20 },
      undefined,
      false
    );

    return (res.data?.items || []).map((it: LabelValue) => ({
      label: it.label,
      value: it.value,
    }));
  }, []);

  const handlePriceRangeChange = (e: ChangeEvent<HTMLInputElement>) => {
    setIsPriceRange(e.target.checked);
  };

  return (
    <div className="w-[100%] max-w-[700px]">
      <div className="text-[#343C6A] font-medium mb-2">Campaign</div>
      <div className="bg-white py-6 px-5 rounded-xl">
        <div className="mt-7">
          <label className="text-sm text-[#343C6A] font-medium mb-2 block">
            Tên campaign
          </label>
          <FormControl name="name">
            <Input placeholder="Nhập tên campaign" />
          </FormControl>
        </div>
        <div className="mt-7">
          <label className="text-sm text-[#343C6A] font-medium mb-2 block">
            Các user id test
          </label>
          <FormControl name="campaignTestingIds">
            <Input placeholder="Nhập ID, cách nhau dấu phẩy" />
          </FormControl>
          <div className="text-xs text-[#83898C] mt-1">
            Nhập các userId cách nhau bởi dấu &quot;,&quot;. Ex: 1,2,3
          </div>
        </div>
        <div className="mt-7">
          <label className="text-sm text-[#343C6A] font-medium mb-2 block">
            Phần trăm giảm giá
          </label>
          <FormControl name="discount">
            <Input
              className="w-[50%]"
              placeholder="Nhập phần trăm giảm giá"
              type="number"
            />
          </FormControl>
        </div>
        <div className="flex justify-between w-full mt-7">
          <div className="w-[48%]">
            <label className="text-sm text-[#343C6A] font-medium mb-2 block">
              Thời gian kích hoạt
            </label>
            <FormControl name="startDate">
              <Input type="date" placeholder="Chọn ngày bắt đầu" />
            </FormControl>
          </div>
          <div className="w-[48%]">
            <label className="text-sm text-[#343C6A] font-medium mb-2 block">
              Thời gian kết thúc
            </label>
            <FormControl name="endDate">
              <Input type="date" placeholder="Chọn ngày kết thúc" />
            </FormControl>
          </div>
        </div>
        <label htmlFor="">
          <div className="mt-3 flex">
            <Checkbox
              label="Loại user"
              labelClassName="text-sm text-[#83898C]"
              onChange={handleTypeUserChange}
              checked={isTypeUser}
            />
          </div>
        </label>

        {isTypeUser && (
          <>
            <div className="w-[50%] mt-4">
              <label className="text-sm text-[#343C6A] font-medium mb-2 block">
                Loại user
              </label>
              <FormControl name="campaignUserType">
                <CustomAsyncMultiSelect
                  promiseOptions={fetchUserOptions}
                  className="rounded-lg"
                  placeholder="Chọn loại user"
                />
              </FormControl>
            </div>
            <div className="w-[50%] mt-4">
              <label className="text-sm text-[#343C6A] font-medium mb-2 block">
                User đã nghe trên số phút
              </label>
              <FormControl name="campaignUserListenedToMinutes">
                <Input type="number" placeholder="Nhập số phút" />
              </FormControl>
            </div>
            <div className="w-[50%] mt-4">
              <label className="text-sm text-[#343C6A] font-medium mb-2 block">
                Tài khoản kas của user đang lớn hơn
              </label>
              <FormControl name="campaignKasIsGreaterThan">
                <Input type="number" placeholder="Nhập số kas" />
              </FormControl>
            </div>
            <div className="w-[50%] mt-4">
              <label className="text-sm text-[#343C6A] font-medium mb-2 block">
                Tài khoản kas của user đang nhỏ hơn
              </label>
              <FormControl name="campaignKasIsLessThan">
                <Input type="number" placeholder="Nhập số kas" />
              </FormControl>
            </div>
            <div className="w-[100%] mt-4">
              <label className="text-sm text-[#343C6A] font-medium mb-2 block">
                User đang có sách lẻ
              </label>
              <FormControl name="campaignHasPurchasedBooks">
                <CustomAsyncMultiSelect
                  placeholder="Chọn sách user đã mua"
                  promiseOptions={fetchBookOptions as any}
                />
              </FormControl>
            </div>
            <div className="w-[100%] mt-4">
              <label className="text-sm text-[#343C6A] font-medium mb-2 block">
                User chưa có sách lẻ
              </label>
              <FormControl name="campaignNotHasPurchasedBooks">
                <CustomAsyncMultiSelect
                  placeholder="Chọn sách user chưa mua"
                  promiseOptions={fetchBookOptions as any}
                />
              </FormControl>
            </div>
          </>
        )}
        <label htmlFor="">
          <div className="mt-3 flex">
            <Checkbox
              label="Khoảng giá"
              labelClassName="text-sm text-[#83898C]"
              onChange={handlePriceRangeChange}
              checked={isPriceRange}
            />
          </div>
        </label>
        {isPriceRange && (
          <div className="mt-4">
            <label className="text-sm text-[#343C6A] font-medium mb-2 block">
              Khoảng giá
            </label>
            <div className="flex justify-between w-[50%] gap-4">
              <div className="w-[48%]">
                <label className="text-xs text-[#83898C] mb-1 block">
                  Giá thấp nhất
                </label>
                <FormControl name="minPrice">
                  <Input type="number" placeholder="Nhập giá thấp nhất" />
                </FormControl>
              </div>
              <div className="flex items-center justify-center mt-6">-</div>
              <div className="w-[48%]">
                <label className="text-xs text-[#83898C] mb-1 block">
                  Giá cao nhất
                </label>
                <FormControl name="maxPrice">
                  <Input type="number" placeholder="Nhập giá cao nhất" />
                </FormControl>
              </div>
            </div>
          </div>
        )}
        <label htmlFor="">
          <div className="mt-3 flex">
            <FormControl name="campaignBirthday">
              <Checkbox
                label="Sinh nhật trong khoảng thời gian campaign"
                labelClassName="text-sm text-[#83898C]"
              />
            </FormControl>
          </div>
        </label>
      </div>
    </div>
  );
};

export default CampaignComponent;
